import { ReactNode } from "react"

// UI
import {
	Tooltip as BaseTooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "@/components/ui/tooltip"

interface TooltipProps {
	content: ReactNode
	children: ReactNode
	className?: string
	enabled?: boolean
}

/**
 * Tooltip
 * @param param0
 * @returns
 */
export function Tooltip({
	content,
	children,
	className = "",
	enabled = true,
}: TooltipProps) {
	return (
		<>
			{enabled === true ? (
				<TooltipProvider>
					<BaseTooltip>
						<TooltipTrigger className={className}>
							{children}
						</TooltipTrigger>
						<TooltipContent>{content}</TooltipContent>
					</BaseTooltip>
				</TooltipProvider>
			) : (
				children
			)}
		</>
	)
}
